/* eslint-disable no-console */
/* eslint-disable react/no-is-mounted */
/** @module 工具模块-公共库日志类 */

const reviseType = (params) => Object.prototype.toString.call(params).slice(8, -1); // 返回变量的类型

const LevelEnum = {
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error',
};

/**
 * 通用日志类
 */
class Logger {
  static mInstance;

  static getInstance() {
    if (!Logger.mInstance) {
      Logger.mInstance = new Logger();
    }
    return Logger.mInstance;
  }

  setConf(config) {
    this.logLevel = config.logLevel || 'info';
  }

  /**
   * @description log级别日志输出 (当前仅作为debug的别名)
   * @param {string} tag 日志输出标签
   * @param {array} meta
   * @return {void}
   */
  log(tag, meta) {
    this.print(LevelEnum.debug, tag, meta);
  }

  /**
   * @description debug级别日志输出
   * @param {string} tag 日志输出标签
   * @param {array} meta
   * @return {void}
   */
  debug(tag, meta) {
    this.print(LevelEnum.debug, tag, meta);
  }

  /**
   * @description info级别日志输出
   * @param {string} tag 日志输出标签
   * @param {array} meta
   * @return {void}
   */
  info(tag, meta) {
    this.print(LevelEnum.info, tag, meta);
  }

  /**
   * warn级别日志输出
   * @param {string} tag 日志输出标签
   * @param {array} meta
   * @return {void}
   */
  warn(tag, meta) {
    this.print(LevelEnum.warn, tag, meta);
  }

  /**
   * error级别日志输出
   * @param {string} tag 日志输出标签
   * @param {array} meta
   * @return {void}
   */
  error(tag, meta) {
    this.print(LevelEnum.error, tag, meta);
  }

  /**
   * log 和 info是一个实现，warn和error不支持颜色，浏览器自动高亮颜色,
   * debug对应verbose(Chrome支持)
   * @param {string} level 日志输出级别 (log 和 info是一个实现，warn和error不支持颜色，浏览器自动高亮颜色, debug对应verbose(Chrome支持))
   * @param {string} tag 日志输出标签
   * @param {array} meta 参数
   * @return {void}
   */
  print(level, tag, meta) {
    // const innerLevel = level.toUpperCase();
    let logData = {
      // L: innerLevel,
    };
    const tagType = reviseType(tag);
    const argsType = reviseType(meta);

    if (tagType === 'String') {
      logData.M = tag; // 如果传入的tag为字符，会被当作M的参数进行收集

      if (argsType === 'Object') {
        // 对应的是 logger.info('', {})
        logData = Object.assign(logData, meta);
      }
    }

    // 第一个参数就是 object, 将忽略后面的参数
    if (tagType === 'Object') {
      logData = Object.assign(logData, tag);
    }
    console.log(JSON.stringify(logData));
  }
}

module.exports = Logger.getInstance();
